module.exports = __webpack_public_path__ + "img/安全生产.ec7653ce.ec7653ce.jpg";